<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class CldRequestService extends Vue {
  static getAllCldConfigs() {
    const response = axios.get('/api/loanimporter/fi').then((data) => {
      if (data.data === null) {
        console.log('No data');
        return [];
      }
      return data.data;
    });
    return response;
  }

  static updateCldConfig(cldConfigPayload) {
    const payload = {};
    const keys = Object.keys(cldConfigPayload);
    const values = Object.values(cldConfigPayload);
    for (let i = 0; i < keys.length; i++) {
      payload[keys[i]] = values[i];
    }
    console.log('Submitting CLD importer config');
    axios
      .put('/api/loanimporter/fi', payload);
  }

  static deleteCldConfig(item) {
    const url = `/api/loanimporter/fi/${item.uuId}/${item.fiId}`;
    console.log('Submitting CLD loan importer config to delete');
    const response = axios.delete(url).then((res) => {
      if (res.status === 200) {
        return true;
      }
      return false;
    });
    return response;
  }
}
</script>
